import React from "react";
import { useMediaQuery } from "react-responsive";
import { Modal } from "react-materialize";
import { useDispatch, useSelector } from "react-redux";
import {
  addedBankDetailsAction,
  getWalletAction,
} from "../../../redux/action/wallet";
import WalletAddBank from "../../commanPage/wallet/children/WalletAddBank";
import AccountHolderTable from "../../commanPage/wallet/table/AccountHolderTable";

function AccountDetails() {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ query: "(max-width: 600px)" });
  const { loadings } = useSelector((state) => state.addBank);

  function addBankDataFetching(obj) {
    dispatch(addedBankDetailsAction(obj))
      .then(() => dispatch(getWalletAction()))
      .then(() => {
        const locationModal = document.getElementById("modalAccounts");
        const instance = window.M.Modal.getInstance(locationModal);
        instance.close();
      });
  }

  return (
    <div className="mt-1">
      <div
        className={` ${
          isMobile ? "flex column gap-1" : "valign-wrapper"
        } space-between `}
        style={{ marginBottom: "14px" }}
      >
        <span className="valign-wrapper" style={{ gap: "25px", flex: "0.97" }}>
          <h4 className="margin-0px">Your Account</h4>
        </span>

        <span
          className="cover modal-trigger white valign-wrapper gap-1 valign-wrapper justify-center pointer bold font-18px"
          style={{ padding: "0.5rem 2rem" }}
          href="#modalAccounts"
        >
          <span className="material-symbols-outlined">add</span>
          <b className="">Add Bank</b>
        </span>
      </div>
      <AccountHolderTable />
      <Modal
        actions={[]}
        bottomSheet={false}
        fixedFooter={false}
        className="modelAccount"
        id="modalAccounts"
        open={false}
      >
        <WalletAddBank
          addBankDataFetching={addBankDataFetching}
          loadings={loadings}
        />
      </Modal>
    </div>
  );
}

export default AccountDetails;
